import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { handleOneDriveCallback } from '@/lib/onedrive'

export default function OneDriveCallback() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const code = params.get('code')
    if (!code) {
      setError('No authorisation code received.')
      return
    }
    handleOneDriveCallback(code)
      .then(() => navigate('/settings', { replace: true }))
      .catch(e => setError(e.message))
  }, [params, navigate])

  if (error) return (
    <div className="p-6 text-red-600 text-sm">
      OneDrive connection failed: {error}
    </div>
  )

  return (
    <div className="flex items-center justify-center min-h-screen text-slate-500 text-sm">
      Connecting OneDrive…
    </div>
  )
}
